export type ColorScheme = {
  id: string;
  name: string;
  description: string;
  primary: string;
  secondary: string;
  gradient: string;
};

export const colorSchemes: ColorScheme[] = [
  {
    id: 'sky',
    name: 'Sky',
    description: 'Clean and modern blue tones',
    primary: '#0ea5e9',
    secondary: '#64748b',
    gradient: 'linear-gradient(135deg, #0ea5e9 0%, #38bdf8 45%, #a5f3fc 100%)',
  },
  {
    id: 'violet',
    name: 'Violet',
    description: 'Premium purple with soft accents',
    primary: '#7c3aed',
    secondary: '#0f172a',
    gradient: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 50%, #fde68a 140%)',
  },
  {
    id: 'emerald',
    name: 'Emerald',
    description: 'Fresh green with professional contrast',
    primary: '#10b981',
    secondary: '#0f172a',
    gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 45%, #a7f3d0 100%)',
  },
  {
    id: 'sunset',
    name: 'Sunset',
    description: 'Warm and energetic (orange/pink)',
    primary: '#f97316',
    secondary: '#334155',
    gradient: 'linear-gradient(135deg, #f97316 0%, #fb7185 55%, #fda4af 100%)',
  },
  {
    id: 'midnight',
    name: 'Midnight',
    description: 'Elegant dark with neon accent',
    primary: '#22c55e',
    secondary: '#e2e8f0',
    gradient: 'linear-gradient(135deg, #0b1220 0%, #111827 55%, #1f2937 100%)',
  },
];

export const getColorSchemeById = (id?: string | null): ColorScheme => {
  const safe = String(id || '').trim();
  return colorSchemes.find((s) => s.id === safe) || colorSchemes[0];
};
